export var ContentCardMegaThemeDefault = {
    typography: {
        h1: {
            headerFont: 'SERIF',
            headerSize: {
                mobile: '24px',
                tablet: '24px',
                desktop: '24px'
            },
            headerLetterSpacing: {
                mobile: '0',
                tablet: '0',
                desktop: '0'
            },
            headerLineHeight: {
                mobile: '1.15em',
                tablet: '1.15em',
                desktop: '1.15em'
            },
            headerSpaceAfter: {
                mobile: '8px',
                tablet: '8px',
                desktop: '8px'
            }
        },
        h2: {
            headerFont: 'SERIF',
            headerSize: {
                mobile: '24px',
                tablet: '24px',
                desktop: '24px'
            },
            headerLetterSpacing: {
                mobile: '0',
                tablet: '0',
                desktop: '0'
            },
            headerLineHeight: {
                mobile: '1.15em',
                tablet: '1.15em',
                desktop: '1.15em'
            },
            headerSpaceAfter: {
                mobile: '8px',
                tablet: '8px',
                desktop: '8px'
            }
        },
        h3: {
            headerFont: 'SERIF',
            headerSize: {
                mobile: '24px',
                tablet: '24px',
                desktop: '24px'
            },
            headerLetterSpacing: {
                mobile: '0',
                tablet: '0',
                desktop: '0'
            },
            headerLineHeight: {
                mobile: '1.15em',
                tablet: '1.15em',
                desktop: '1.15em'
            },
            headerSpaceAfter: {
                mobile: '8px',
                tablet: '8px',
                desktop: '8px'
            }
        },
        h4: {
            headerFont: 'SERIF',
            headerSize: {
                mobile: '24px',
                tablet: '24px',
                desktop: '24px'
            },
            headerLetterSpacing: {
                mobile: '0',
                tablet: '0',
                desktop: '0'
            },
            headerLineHeight: {
                mobile: '1.15em',
                tablet: '1.15em',
                desktop: '1.15em'
            },
            headerSpaceAfter: {
                mobile: '8px',
                tablet: '8px',
                desktop: '8px'
            }
        },
        h5: {
            headerFont: 'SERIF',
            headerSize: {
                mobile: '24px',
                tablet: '24px',
                desktop: '24px'
            },
            headerLetterSpacing: {
                mobile: '0',
                tablet: '0',
                desktop: '0'
            },
            headerLineHeight: {
                mobile: '1.15em',
                tablet: '1.15em',
                desktop: '1.15em'
            },
            headerSpaceAfter: {
                mobile: '8px',
                tablet: '8px',
                desktop: '8px'
            }
        },
        h6: {
            headerFont: 'SERIF',
            headerSize: {
                mobile: '24px',
                tablet: '24px',
                desktop: '24px'
            },
            headerLetterSpacing: {
                mobile: '0',
                tablet: '0',
                desktop: '0'
            },
            headerLineHeight: {
                mobile: '1.15em',
                tablet: '1.15em',
                desktop: '1.15em'
            },
            headerSpaceAfter: {
                mobile: '8px',
                tablet: '8px',
                desktop: '8px'
            }
        },
        secondaryHeader: {
            secondaryHeaderFont: 'SANS-SERIF',
            secondaryHeaderSize: {
                mobile: '14px',
                tablet: '14px',
                desktop: '14px'
            },
            secondaryHeaderLetterSpacing: {
                mobile: '0',
                tablet: '0',
                desktop: '0'
            },
            secondaryHeaderLineHeight: {
                mobile: '1',
                tablet: '1',
                desktop: '1'
            },
            secondaryHeaderSpaceAfter: {
                mobile: '4px',
                tablet: '4px',
                desktop: '4px'
            }
        },
        body: {
            bodyFont: 'SANS_SERIF',
            bodySize: {
                mobile: '16px',
                tablet: '16px',
                desktop: '16px'
            },
            bodyLetterSpacing: {
                mobile: '0',
                tablet: '0',
                desktop: '0'
            },
            bodyLineHeight: {
                mobile: '1.33em',
                tablet: '1.33em',
                desktop: '1.33em'
            },
            bodySpaceAfter: {
                mobile: '24px',
                tablet: '24px',
                desktop: '24px'
            }
        }
    }
};
export var ContentCardRegularThemeDefault = {
    typography: {
        h1: {
            headerFont: 'SERIF',
            headerSize: {
                mobile: '20px',
                tablet: '20px',
                desktop: '20px'
            },
            headerLetterSpacing: {
                mobile: '0',
                tablet: '0',
                desktop: '0'
            },
            headerLineHeight: {
                mobile: '1.15em',
                tablet: '1.15em',
                desktop: '1.15em'
            },
            headerSpaceAfter: {
                mobile: '8px',
                tablet: '8px',
                desktop: '8px'
            }
        },
        h2: {
            headerFont: 'SERIF',
            headerSize: {
                mobile: '20px',
                tablet: '20px',
                desktop: '20px'
            },
            headerLetterSpacing: {
                mobile: '0',
                tablet: '0',
                desktop: '0'
            },
            headerLineHeight: {
                mobile: '1.15em',
                tablet: '1.15em',
                desktop: '1.15em'
            },
            headerSpaceAfter: {
                mobile: '8px',
                tablet: '8px',
                desktop: '8px'
            }
        },
        h3: {
            headerFont: 'SERIF',
            headerSize: {
                mobile: '20px',
                tablet: '20px',
                desktop: '20px'
            },
            headerLetterSpacing: {
                mobile: '0',
                tablet: '0',
                desktop: '0'
            },
            headerLineHeight: {
                mobile: '1.15em',
                tablet: '1.15em',
                desktop: '1.15em'
            },
            headerSpaceAfter: {
                mobile: '8px',
                tablet: '8px',
                desktop: '8px'
            }
        },
        h4: {
            headerFont: 'SERIF',
            headerSize: {
                mobile: '20px',
                tablet: '20px',
                desktop: '20px'
            },
            headerLetterSpacing: {
                mobile: '0',
                tablet: '0',
                desktop: '0'
            },
            headerLineHeight: {
                mobile: '1.15em',
                tablet: '1.15em',
                desktop: '1.15em'
            },
            headerSpaceAfter: {
                mobile: '8px',
                tablet: '8px',
                desktop: '8px'
            }
        },
        h5: {
            headerFont: 'SERIF',
            headerSize: {
                mobile: '20px',
                tablet: '20px',
                desktop: '20px'
            },
            headerLetterSpacing: {
                mobile: '0',
                tablet: '0',
                desktop: '0'
            },
            headerLineHeight: {
                mobile: '1.15em',
                tablet: '1.15em',
                desktop: '1.15em'
            },
            headerSpaceAfter: {
                mobile: '8px',
                tablet: '8px',
                desktop: '8px'
            }
        },
        h6: {
            headerFont: 'SERIF',
            headerSize: {
                mobile: '20px',
                tablet: '20px',
                desktop: '20px'
            },
            headerLetterSpacing: {
                mobile: '0',
                tablet: '0',
                desktop: '0'
            },
            headerLineHeight: {
                mobile: '1.15em',
                tablet: '1.15em',
                desktop: '1.15em'
            },
            headerSpaceAfter: {
                mobile: '8px',
                tablet: '8px',
                desktop: '8px'
            }
        },
        secondaryHeader: {
            secondaryHeaderFont: 'SANS-SERIF',
            secondaryHeaderSize: {
                mobile: '12px',
                tablet: '12px',
                desktop: '12px'
            },
            secondaryHeaderLetterSpacing: {
                mobile: '0',
                tablet: '0',
                desktop: '0'
            },
            secondaryHeaderLineHeight: {
                mobile: '1',
                tablet: '1',
                desktop: '1'
            },
            secondaryHeaderSpaceAfter: {
                mobile: '4px',
                tablet: '4px',
                desktop: '4px'
            }
        },
        body: {
            bodyFont: 'SANS_SERIF',
            bodySize: {
                mobile: '14px',
                tablet: '14px',
                desktop: '14px'
            },
            bodyLetterSpacing: {
                mobile: '0',
                tablet: '0',
                desktop: '0'
            },
            bodyLineHeight: {
                mobile: '1.33em',
                tablet: '1.33em',
                desktop: '1.33em'
            },
            bodySpaceAfter: {
                mobile: '24px',
                tablet: '24px',
                desktop: '24px'
            }
        }
    }
};
export var ContentCardMiniThemeDefault = {
    typography: {
        h1: {
            headerFont: 'SERIF',
            headerSize: {
                mobile: '16px',
                tablet: '16px',
                desktop: '16px'
            },
            headerLetterSpacing: {
                mobile: '0',
                tablet: '0',
                desktop: '0'
            },
            headerLineHeight: {
                mobile: '1.15em',
                tablet: '1.15em',
                desktop: '1.15em'
            },
            headerSpaceAfter: {
                mobile: '8px',
                tablet: '8px',
                desktop: '8px'
            }
        },
        h2: {
            headerFont: 'SERIF',
            headerSize: {
                mobile: '16px',
                tablet: '16px',
                desktop: '16px'
            },
            headerLetterSpacing: {
                mobile: '0',
                tablet: '0',
                desktop: '0'
            },
            headerLineHeight: {
                mobile: '1.15em',
                tablet: '1.15em',
                desktop: '1.15em'
            },
            headerSpaceAfter: {
                mobile: '8px',
                tablet: '8px',
                desktop: '8px'
            }
        },
        h3: {
            headerFont: 'SERIF',
            headerSize: {
                mobile: '16px',
                tablet: '16px',
                desktop: '16px'
            },
            headerLetterSpacing: {
                mobile: '0',
                tablet: '0',
                desktop: '0'
            },
            headerLineHeight: {
                mobile: '1.15em',
                tablet: '1.15em',
                desktop: '1.15em'
            },
            headerSpaceAfter: {
                mobile: '8px',
                tablet: '8px',
                desktop: '8px'
            }
        },
        h4: {
            headerFont: 'SERIF',
            headerSize: {
                mobile: '16px',
                tablet: '16px',
                desktop: '16px'
            },
            headerLetterSpacing: {
                mobile: '0',
                tablet: '0',
                desktop: '0'
            },
            headerLineHeight: {
                mobile: '1.15em',
                tablet: '1.15em',
                desktop: '1.15em'
            },
            headerSpaceAfter: {
                mobile: '8px',
                tablet: '8px',
                desktop: '8px'
            }
        },
        h5: {
            headerFont: 'SERIF',
            headerSize: {
                mobile: '16px',
                tablet: '16px',
                desktop: '16px'
            },
            headerLetterSpacing: {
                mobile: '0',
                tablet: '0',
                desktop: '0'
            },
            headerLineHeight: {
                mobile: '1.15em',
                tablet: '1.15em',
                desktop: '1.15em'
            },
            headerSpaceAfter: {
                mobile: '8px',
                tablet: '8px',
                desktop: '8px'
            }
        },
        h6: {
            headerFont: 'SERIF',
            headerSize: {
                mobile: '16px',
                tablet: '16px',
                desktop: '16px'
            },
            headerLetterSpacing: {
                mobile: '0',
                tablet: '0',
                desktop: '0'
            },
            headerLineHeight: {
                mobile: '1.15em',
                tablet: '1.15em',
                desktop: '1.15em'
            },
            headerSpaceAfter: {
                mobile: '8px',
                tablet: '8px',
                desktop: '8px'
            }
        },
        secondaryHeader: {
            secondaryHeaderFont: 'SANS-SERIF',
            secondaryHeaderSize: {
                mobile: '12px',
                tablet: '12px',
                desktop: '12px'
            },
            secondaryHeaderLetterSpacing: {
                mobile: '0',
                tablet: '0',
                desktop: '0'
            },
            secondaryHeaderLineHeight: {
                mobile: '1',
                tablet: '1',
                desktop: '1'
            },
            secondaryHeaderSpaceAfter: {
                mobile: '4px',
                tablet: '4px',
                desktop: '4px'
            }
        },
        body: {
            bodyFont: 'SANS_SERIF',
            bodySize: {
                mobile: '14px',
                tablet: '14px',
                desktop: '14px'
            },
            bodyLetterSpacing: {
                mobile: '0',
                tablet: '0',
                desktop: '0'
            },
            bodyLineHeight: {
                mobile: '1.33',
                tablet: '1.33',
                desktop: '1.33'
            },
            bodySpaceAfter: {
                mobile: '24px',
                tablet: '24px',
                desktop: '24px'
            }
        }
    }
};
